import React from "react";
import { Loader2 } from "lucide-react";

type SpinnerProps = {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeToClass: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};

export function Spinner({ label, size = "md", className = "" }: SpinnerProps) {
  return (
    <span className={`inline-flex items-center gap-2 text-slate-600 dark:text-slate-300 ${className}`}>
      <Loader2 className={`${sizeToClass[size]} animate-spin`} />
      {label && <span className="text-sm">{label}</span>}
    </span>
  );
}
